import { render, staticRenderFns } from "./BindingModal.vue?vue&type=template&id=518b047f&scoped=true"
import script from "./BindingModal.vue?vue&type=script&lang=js"
export * from "./BindingModal.vue?vue&type=script&lang=js"
import style0 from "./BindingModal.vue?vue&type=style&index=0&id=518b047f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b047f",
  null
  
)

export default component.exports